import { MetadataStore } from 'breeze-client';

import { AspNetRole } from './asp-net-role';
import { AspNetUser } from './asp-net-user';
import { AspNetUserClaim } from './asp-net-user-claim';
import { AspNetUserRole } from './asp-net-user-role';
import { AspNetUserToken } from './asp-net-user-token';
import { ClientLicense } from './client-license';
import { Feature } from './feature';
import { FeatureSetting } from './feature-setting';
import { License } from './license';
import { Product } from './product';

export class AuthRegistrationHelper {

    static register(metadataStore: MetadataStore) {
        metadataStore.registerEntityTypeCtor('AspNetRole', AspNetRole);
        metadataStore.registerEntityTypeCtor('AspNetUser', AspNetUser);
        metadataStore.registerEntityTypeCtor('AspNetUserClaim', AspNetUserClaim);
        metadataStore.registerEntityTypeCtor('AspNetUserRole', AspNetUserRole);
        metadataStore.registerEntityTypeCtor('AspNetUserToken', AspNetUserToken);
        metadataStore.registerEntityTypeCtor('ClientLicense', ClientLicense);
        metadataStore.registerEntityTypeCtor('Feature', Feature);
        metadataStore.registerEntityTypeCtor('FeatureSetting', FeatureSetting);
        metadataStore.registerEntityTypeCtor('License', License);
        metadataStore.registerEntityTypeCtor('Product', Product);
    }
}
